module.exports = __webpack_public_path__ + "img/der_02_machine.4265eb06.gif";